import { MetricCard } from '@/components/layout/MetricCard';
import { PageSection } from '@/components/layout/PageSection';
import { StatusBadge } from '@/components/StatusBadge';

const metrics = [
  { label: 'Total Listings', value: '24' },
  { label: 'Published', value: '18' },
  { label: 'Drafts', value: '6' },
];

const recentListings = [
  {
    id: 1,
    title: 'Modern Downtown Apartment',
    type: 'Apartment',
    city: 'San Francisco',
    price: '$850,000',
    status: 'Published',
  },
  {
    id: 2,
    title: 'Cozy Family House',
    type: 'House',
    city: 'Austin',
    price: '$620,000',
    status: 'Published',
  },
  {
    id: 3,
    title: 'Luxury Villa with Pool',
    type: 'Villa',
    city: 'Miami',
    price: '$1,200,000',
    status: 'Draft',
  },
  {
    id: 4,
    title: 'Studio Near Campus',
    type: 'Studio',
    city: 'Boston',
    price: '$320,000',
    status: 'Published',
  },
  {
    id: 5,
    title: 'Spacious Suburban Home',
    type: 'House',
    city: 'Seattle',
    price: '$740,000',
    status: 'Published',
  },
];

export function Dashboard() {
  return (
    <div className="th-container space-y-[48px]">
      {/* Metrics */}
      <div className="grid grid-cols-3 gap-[24px]">
        {metrics.map((metric) => (
          <MetricCard key={metric.label} label={metric.label} value={metric.value} />
        ))}
      </div>

      {/* Recent Listings */}
      <PageSection title="Recent Listings" className="dashboard-listings-card p-[24px]">
        <div className="overflow-x-auto">
          <table className="table-clean w-full">
            <thead>
              <tr className="border-b border-[#e5e5e5]">
                <th className="py-4 px-4 text-left font-medium text-[13px] text-[#8d8c8f]">
                  Title
                </th>
                <th className="py-4 px-4 text-left font-medium text-[13px] text-[#8d8c8f]">Type</th>
                <th className="py-4 px-4 text-left font-medium text-[13px] text-[#8d8c8f]">City</th>
                <th className="py-4 px-4 text-left font-medium text-[13px] text-[#8d8c8f]">
                  Price
                </th>
                <th className="py-4 px-4 text-left font-medium text-[13px] text-[#8d8c8f]">
                  Status
                </th>
              </tr>
            </thead>
            <tbody>
              {recentListings.map((listing) => (
                <tr
                  key={listing.id}
                  className="border-b border-[#e5e5e5] last:border-0 hover:bg-[#f5f5f5] transition-colors"
                >
                  <td className="py-3 px-4 text-[14px] text-[#181818]">{listing.title}</td>
                  <td className="py-3 px-4 text-[14px] text-[#646464]">{listing.type}</td>
                  <td className="py-3 px-4 text-[14px] text-[#646464]">{listing.city}</td>
                  <td className="py-3 px-4 text-[14px] text-[#181818]">{listing.price}</td>
                  <td className="py-3 px-4">
                    <StatusBadge
                      status={listing.status === 'Published' ? 'published' : 'draft'}
                      className="h-7 px-[16px] text-[13px] rounded-full"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </PageSection>
    </div>
  );
}
